﻿import axios from 'axios';

const instance = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
});

instance.CancelToken = axios.CancelToken;

/*
instance.interceptors.request.use(
    config => {
        const token = GetTokenFromCookieOrStorage() 
        if (token)
            config.headers['Authorization'] = `Bearer ${token}`;

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
*/

export default instance;